import { Modal } from "react-bootstrap";
import { toast } from "sonner";
import { createEDT } from "../../api/edt";
import { useEffect, useState } from "react";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import { OverlayTrigger, Popover } from "react-bootstrap";

import { Calendar } from "antd";

import dayjs from "dayjs";
import "dayjs/locale/fr";
import "antd/dist/reset.css";
import { getWeeksMondaySunday } from "../../helper/getWeeksMondaySunday";
import { parseAcademicYearString } from "../../helper/parseAcademicYearString";
import withPermission from "../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";

type Props = {
  show: boolean;
  published?: boolean;
  days: any[];
  slots: any[];
  seances: any[];
  courses: any[];
  newEDTName?: string;
  setTimetableId?: (id: string) => void;
  setTimetableVersion?: (version: string) => void;
  placedCourses: any[];
  onClose: () => void;
};

const EDTCreateModal = ({
  show,
  seances,
  slots,
  days,
  published,
  setTimetableId,
  setTimetableVersion,
  newEDTName,
  placedCourses,
  onClose,
}: Props) => {
  const { selectedYear } = useAcademicYear();
  const [weeksOfYear, setWeeksOfYear] = useState<number[]>([]);
  const [selectedWeek, setSelectedWeek] = useState<number>();
  const [isPublished, setIsPublished] = useState<boolean>(published || false);
  const [yearsOfSholarship, setYearsOfSholarship] = useState<number[]>([]);
  const [selectedYearScholarship, setselectedYearScholarship] =
    useState<number>();

  const onSave = async () => {
    try {
      if (!selectedYear) return;
      if (!selectedWeek) {
        toast.error("Veuillez sélectionner une semaine de validité.");
        return;
      }

      const EDTData = {
        state_edt: "Brouillon",
        title: newEDTName,
        id_academicYear: selectedYear?.id,
        valid_from: dayjs(
          getWeeksMondaySunday(
            selectedYearScholarship || new Date().getFullYear(),
          )[selectedWeek - 1][0],
        ).format("YYYY-MM-DD"),
        valid_until: dayjs(
          getWeeksMondaySunday(
            selectedYearScholarship || new Date().getFullYear(),
          )[selectedWeek - 1][6],
        ).format("YYYY-MM-DD"),
      };

      const response = await createEDT(EDTData);

      // console.log("FormattedPlacedCourse: ",formattedPlacedCourse)
      // const res = await createEDTCours({
      //   id_versionEDT: response.data.version.id,
      //   courses: formattedPlacedCourse,
      // });
      setTimetableId?.(response.data.id);
      setTimetableVersion?.(response.data.version.id);
      // console.log("response: ", res);
      onClose();
    } catch (error: any) {
      // console.log("erreur lors de l a création de l'EDT : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  useEffect(() => {
    if (!selectedYear) return;
    const years = parseAcademicYearString(selectedYear?.label);
    setYearsOfSholarship(years.map((y) => parseInt(y)));
    // setSelectedWeek(1);
  }, [selectedYear]);

  useEffect(() => {
    if (!yearsOfSholarship.length) return;
    setselectedYearScholarship(yearsOfSholarship[0]);
  }, [yearsOfSholarship]);

  useEffect(() => {
    if (!selectedYearScholarship) return;
    const weeks = getWeeksMondaySunday(selectedYearScholarship);
    setWeeksOfYear(weeks.map((_, i) => i + 1));
    setSelectedWeek(undefined);
  }, [selectedYearScholarship]);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-4">
          <i className="ion ion-calendar fs-2"></i>
          <h5 className="modal-title">Sauvegarder {newEDTName}</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="d-flex flex-column gap-3">
          {/* Select pour les années de l'année scolaire */}
          <div className="form-group">
            <label>Année scolaire</label>
            <select
              className="form-select"
              value={selectedYearScholarship}
              onChange={(e) =>
                setselectedYearScholarship(parseInt(e.target.value))
              }
            >
              {yearsOfSholarship.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Période de validité (semaines de l'année académique)</label>
            <div className="d-flex flex-wrap gap-2 mt-2">
              {weeksOfYear.map((w, index) => {
                const allWeeks = getWeeksMondaySunday(
                  selectedYearScholarship || new Date().getFullYear(),
                );
                const weekDays = allWeeks[index] || []; // les 7 jours de la semaine

                return (
                  <OverlayTrigger
                    key={w}
                    placement="top"
                    overlay={
                      <Popover id={`popover-week-${w}`}>
                        <Popover.Body>
                          <div>
                            <Calendar
                              fullscreen={false}
                              // locale={frFR}
                              mode="month"
                              defaultValue={dayjs(weekDays[0])}
                              disabledDate={() => true}
                              headerRender={({
                                value,
                                type,
                                onChange,
                                onTypeChange,
                              }) => {
                                return (
                                  <div
                                    style={{
                                      padding: "8px 0",
                                      textAlign: "center",
                                    }}
                                  >
                                    <span>
                                      Semaine {w} - {value.format("MMMM YYYY")}
                                    </span>
                                  </div>
                                );
                              }}
                              fullCellRender={(date) => {
                                const isInWeek = weekDays.some(
                                  (day) =>
                                    day.getDate() === date.date() &&
                                    day.getMonth() === date.month() &&
                                    day.getFullYear() === date.year(),
                                );
                                const isFirstDay =
                                  date.date() === weekDays[0].getDate() &&
                                  date.month() === weekDays[0].getMonth() &&
                                  date.year() === weekDays[0].getFullYear();
                                const isLastDay =
                                  date.date() === weekDays[6].getDate() &&
                                  date.month() === weekDays[6].getMonth() &&
                                  date.year() === weekDays[6].getFullYear();
                                return (
                                  <div
                                    style={{
                                      height: "24px",
                                      width: "100%",
                                      textAlign: "center",
                                      lineHeight: "24px",
                                      backgroundColor:
                                        isFirstDay || isLastDay
                                          ? "#0d6efd"
                                          : isInWeek
                                            ? "#6ab0f0"
                                            : "transparent",
                                      color: isInWeek ? "white" : "inherit",
                                      borderRadius:
                                        isFirstDay || isLastDay ? "5px" : "",
                                    }}
                                  >
                                    {date.date()}
                                  </div>
                                );
                              }}
                            />
                          </div>
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <div
                      className="form-check form-check-inline p-0 m-0"
                      style={{ width: 40, height: 40 }}
                    >
                      <input
                        className="d-none"
                        type="checkbox"
                        id={`week-${w}`}
                        value={w}
                        checked={selectedWeek === w}
                        // disabled={
                        //   !weekDays.some(
                        //     (d) =>
                        //       d.toDateString() === new Date().toDateString()
                        //   ) && weekDays[6] < new Date()
                        // }
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedWeek(w);
                          }
                        }}
                      />
                      <label
                        className="week-check-label d-flex align-items-center justify-content-center"
                        htmlFor={`week-${w}`}
                        style={{
                          width: 36,
                          height: 36,
                          borderRadius: "50%",
                          border: "2px solid #0d6efd",
                          cursor: "pointer",
                          fontWeight: 500,
                          fontSize: 16,
                          transition: "background 0.2s, color 0.2s",
                          userSelect: "none",
                          opacity:
                            !weekDays.some(
                              (d) =>
                                d.toDateString() === new Date().toDateString(),
                            ) && weekDays[6] < new Date()
                              ? 0.5
                              : 1,
                        }}
                      >
                        {w}
                      </label>
                    </div>
                  </OverlayTrigger>
                );
              })}
            </div>
            <style>
              {`
                  .week-check-label {
                    background: #fff;
                    color: #0d6efd;
                  }
                  input[type="checkbox"]:checked + .week-check-label {
                    background: #0d6efd;
                    color: #fff;
                    border-color: #0d6efd;
                  }
                `}
            </style>
          </div>

          <div className="form-group">
            <label>Status</label>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="statusSwitch"
                checked={isPublished}
                onChange={(e) => setIsPublished(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="statusSwitch">
                Publié ?
              </label>
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 mt-3">
            <button
              onClick={(e) => {
                e.preventDefault();
                onSave();
              }}
              className="btn btn-primary"
            >
              Enregistrer
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default withPermission(
  EDTCreateModal,
  [buildPermission(Resource.EDT, Action.CREATE)],
  "masquer",
);
